import Vue from 'vue'
import Vuex from 'vuex'
import * as client from '@/store/modules/client.js'
import * as product from '@/store/modules/product.js'
import * as unit from '@/store/modules/unit.js'
import * as unitProduct from '@/store/modules/unitProduct.js'
import * as productCategory from '@/store/modules/productCategory.js'
import * as notification from '@/store/modules/notification.js'
import * as cart from '@/store/modules/cart.js'
import * as user from '@/store/modules/user.js'
import * as supplier from '@/store/modules/supplier.js'
import * as payment from '@/store/modules/payment.js'
import * as order from '@/store/modules/order.js'
import * as invoice from '@/store/modules/invoice.js'
import * as subscription from '@/store/modules/subscription.js'
import * as account from '@/store/modules/account.js'
import * as experience from '@/store/modules/experience.js'
import * as marketPlace from '@/store/modules/marketPlace.js'
import * as cleaner from '@/store/modules/cleaner.js'
import * as quickContact from '@/store/modules/quickContact.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    client,
    product,
    unit,
    unitProduct,
    notification,
    cart,
    productCategory,
    user,
    supplier,
    payment,
    order,
    invoice,
    subscription,
    account,
    experience,
    cleaner,
    marketPlace,
    quickContact
  },
  state: {
    unitCategories: ['1', '2', '3', '4']
  }
})
